module.exports = __webpack_public_path__ + "img/e1fb787.png";